import React from "react";
import useGameStore from "../store/gameStore";

const InteractiveTile = React.memo(function InteractiveTile({ tile }) {
  const clickTile = useGameStore((s) => s.clickTile);

  const handleClick = () => {
    clickTile(tile.seq);
  };

  return (
    <div
      style={{
        height: "70px",
        width: "70px",
        backgroundColor: tile.color || "#D9D9D9",
        borderRadius: "10px",
        cursor: tile.cursor || "none",
        pointerEvents: tile.pointerEvents || "none",
      }}
      onClick={handleClick}
    />
  );
});

export default InteractiveTile;
